import React from 'react';
import { View, StyleSheet, Animated, Easing } from 'react-native';
import Svg, { Circle, Path, Rect } from 'react-native-svg';
import { useThemeContext } from '../../../contexts';

/**
 * AcceptCredentialOfferAnimation is a component that displays an animation of a credit card being added to a wallet.
 *
 * @return {React.FC}
 */
const AcceptCredentialOfferAnimation: React.FC = () => {
  const animatedValue = React.useRef(new Animated.Value(0)).current;
  const { theme } = useThemeContext();

  React.useEffect(() => {
    Animated.loop(
      Animated.timing(animatedValue, {
        toValue: 1,
        duration: 3000,
        easing: Easing.bezier(0.25, 1, 0.5, 1),
        useNativeDriver: false
      })
    ).start();
  }, [animatedValue]);

  const translateY = animatedValue.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: [-30, 20, 80]
  });

  const walletScale = animatedValue.interpolate({
    inputRange: [0.3, 0.6, 0.95],
    outputRange: [1, 1.1, 1],
    extrapolate: 'clamp'
  });

  return (
    <View style={styles.container}>
      <View style={styles.animationContainer}>
        <Animated.View
          style={[
            styles.creditCard,
            {
              transform: [{ translateY }]
            }
          ]}>
          <Svg width="100" height="60" viewBox="0 0 100 60">
            <Rect width="100" height="60" rx="8" ry="8" fill={theme.secondary} />
            <Rect x="10" y="15" width="80" height="8" fill="#FFFFFF" />
            <Rect x="10" y="35" width="50" height="5" fill="#FFFFFF" />
            <Rect x="10" y="45" width="30" height="5" fill="#FFFFFF" />
          </Svg>
        </Animated.View>
        <Animated.View
          style={[
            styles.wallet,
            {
              transform: [{ scale: walletScale }]
            }
          ]}>
          <Svg width="120" height="80" viewBox="0 0 120 80">
            <Rect width="120" height="80" rx="10" ry="10" fill={theme.primary} />
            <Path d="M90 35h27v15H90a7.5 7.5 0 0 1 0-15z" fill="#fff" />
            <Circle cx="90" cy="42.5" r="5" fill={theme.primary} />
          </Svg>
        </Animated.View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  animationContainer: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  creditCard: {
    position: 'absolute',
    top: -60,
    left: 10,
    zIndex: 1
  },
  wallet: {
    zIndex: 2,
    overflow: 'hidden',
    width: 120,
    height: 80
  }
});

export default AcceptCredentialOfferAnimation;
